import { webEvent } from "./event";

// When the tooltip of a highlighted item stays open for the usual tooltip delay
export const featureHighlightTooltipShown = (featureId: string) =>
  webEvent("feature_highlight", "tooltip_shown", { featureId });

// When the user clicks "Learn more" in the tooltip of a highlighted item
export const featureHighlightLearnMoreClicked = (featureId: string) =>
  webEvent("feature_highlight", "learn_more_clicked", { featureId });
